import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import openApp from '@tencent/vft-common/openapp';
import atom from '@tencent/vft-atom';
import Clipboard from '@tencent/vft-common/clipboard';
import { request } from '@tencent/vft-common/request';
import util from '@tencent/vft-common/util';
import * as report from './report';
var defaultDescText = 'QQ和微信登录是两个独立帐号，VIP身份不互通，登录前请确认你的常用帐号。'; // 能登录微信

var wxloginWhiteList = ['app', 'wechat', 'weishi'];
var hasOwn = Object.prototype.hasOwnProperty;
var instance;
var cacheWhiteList;
export default {
  data: function data() {
    return {
      appName: '腾讯视频',
      visible: false,
      // 是否显示登录弹窗
      desc: '',
      // 副标题展示
      jumpUrl: '',
      // 登录完成后的跳转地址
      pageUrl: location.href,
      // 页面地址
      isLogin: false,
      // 是否已登录
      isLoginExpired: false,
      // 登录态已过期
      loginType: '',
      // 当前登录类型
      canLoginQQ: !env.isMqq,
      // 能否登录QQ
      canLoginWechat: env.isApp || env.isTenvideoUnion,
      // 能否登录微信
      canOpenApp: false,
      // 能否拉起腾讯视频
      inWxMiniApp: false,
      // 是否在微信小程序内
      env: env.app,
      // 当前环境，wechat
      forceReload: true,
      // 页面回退时，是否强制刷新页面
      isPrivateMode: false,
      // 隐私模式
      insideIframe: false,
      // 兼容 iframe
      isAgreementChecked: false,
      agreement: {
        user: 'https://m.v.qq.com/about/privacy.html',
        privacy: 'https://privacy.qq.com/document/priview/3fab9c7fc1424ebda42c3ce488322c8a',
        kidPrivacy: 'https://privacy.qq.com/mb/policy/kids-privacypolicy',
        personalInfo: 'https://privacy.qq.com/document/preview/18f3ac8cb4364ed8b2ba596a9bfe3111',
        thirdInfo: 'https://privacy.qq.com/document/preview/ba4294dc9d4a45a89f3d682eb07a489b'
      }
    };
  },
  computed: {
    canLogin: function canLogin() {
      return this.canLoginWechat || this.canLoginQQ;
    },
    descText: function descText() {
      if (this.isPrivateMode) {
        return '当前环境cookie已被您设置禁用，无法正常使用登录服务，请您重新打开后重试。您也可以前往腾讯视频App使用本功能或参与本活动。';
      }

      if (env.isMqq) {
        return "\u5982\u9700\u5207\u6362\u5FAE\u4FE1\u5E10\u53F7\uFF0C".concat(this.canOpenApp ? '点击打开腾讯视频，即可使用微信登录；' : '可点击复制链接，发送给任意微信好友，并点击链接，即可登录微信。', "\u5982\u9700\u5207\u6362\u5176\u4ED6QQ\u5E10\u53F7\uFF0C\u53EF\u5728QQ\u3010\u8BBE\u7F6E\u3011\u4E2D\u5207\u6362\u3002").concat(defaultDescText);
      }

      if (env.isWechat && !this.canLoginWechat) {
        return "\u5982\u9700\u5207\u6362\u5FAE\u4FE1\u5E10\u53F7\uFF0C\u8BF7\u5728\u5FAE\u4FE1\u3010\u8BBE\u7F6E\u3011\u2014\u3010\u5207\u6362\u5E10\u53F7\u3011\u4E2D\u5207\u6362\u767B\u5F55\u5E10\u53F7\u3002".concat(defaultDescText);
      }

      if (this.canLoginWechat && this.canLoginQQ) {
        return defaultDescText;
      }

      if (this.canLoginWechat || this.canLoginQQ) {
        var loginTypeName = this.canLoginWechat ? '微信' : 'QQ';
        var disableLoginTypeName = this.canLoginWechat ? 'QQ' : '微信';
        return "\u5F53\u524D\u73AF\u5883\u53EA\u652F\u6301\u767B\u5F55".concat(loginTypeName, "\u5E10\u53F7\uFF0C\u5982\u9700\u767B\u5F55").concat(disableLoginTypeName, "\u5E10\u53F7\uFF0C\u53EF\u70B9\u51FB<span id=\"clipboard\" style=\"color: #ff6022\">\u590D\u5236\u94FE\u63A5</span>\uFF0C\u53D1\u9001\u7ED9\u4EFB\u610F").concat(disableLoginTypeName, "\u597D\u53CB\uFF0C\u5E76\u70B9\u51FB\u94FE\u63A5\uFF0C\u5373\u53EF\u767B\u5F55").concat(disableLoginTypeName, "\u3002").concat(defaultDescText);
      }

      return "\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301QQ\u5E10\u53F7\u548C\u5FAE\u4FE1\u5E10\u53F7\u767B\u5F55\uFF0C".concat(this.canOpenApp ? '请点击打开腾讯视频，' : '请复制链接到微信或者QQ发送给任意好友，再次点击链接', "\u5373\u53EF\u4F7F\u7528\u5E10\u53F7\u767B\u5F55\u3002").concat(defaultDescText);
    }
  },
  created: function created() {
    if (env.isWechat && (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke)) {
      document.addEventListener('WeixinJSBridgeReady', this.init.bind(this), false);
    } else {
      this.init();
    }
  },
  mounted: function mounted() {
    var _this = this;

    instance = this; // fix 微信切换到登录界面时，手动返回页面由于页面 cache 导致页面无刷新问题

    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        // 通过 foceReload=false 避免页面回退的时候，强制刷新
        // 业务可通过注册 reinit 方法，可在回退的时候触发页面异步刷新数据
        if (_this.forceReload) {
          window.location.reload();
        } else if (typeof window.reinit === 'function') {
          window.reinit();
        }
      }
    });
  },
  methods: {
    init: function init() {
      var _this2 = this;

      login.init(function () {
        _this2.isLogin = login.isLogin();
        _this2.loginType = login.loginType();

        _this2.setEnv();
      });
    },

    /**
     * 更新状态
     */
    updateState: function updateState(callback) {
      var _this3 = this;

      var timer = setTimeout(function () {
        callback();
      }, 300);
      login.onInit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isStrictLogin;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isStrictLogin = login.isLogin();

                if (isStrictLogin && login.loginType() === 'qq' && cookie.get('uin') && !cookie.get('skey')) {
                  isStrictLogin = false;
                }

                _context.next = 4;
                return _this3.setEnv();

              case 4:
                clearTimeout(timer);
                _this3.isLogin = login.isLogin();
                _this3.isLoginExpired = !!(!isStrictLogin && login.isLogin());
                _this3.loginType = login.loginType(); // 能登录微信

                if (_this3.env === 'wechat' && _this3.loginType === 'wx' && !_this3.isLoginExpired) {
                  _this3.canLoginWechat = false;
                }

                if (typeof callback === 'function') {
                  callback();
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },

    /**
     * 设置环境
     */
    setEnv: function setEnv() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var appLaunchWhiteList, whiteList, ua, i, len, app, j, _len, conf;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // eslint-disable-next-line no-underscore-dangle
                _this4.inWxMiniApp = window.__wxjs_environment && window.__wxjs_environment === 'miniprogram';
                _this4.canLoginQQ = !env.isMqq && !_this4.inWxMiniApp;
                _this4.isPrivateMode = !navigator.cookieEnabled;
                _this4.isAgreementChecked = false;

                if (env.isTenvideoUnion || _this4.env === 'wechat' && _this4.loginType !== 'wx' || wxloginWhiteList.indexOf(_this4.env) > -1) {
                  _this4.canLoginWechat = true;
                } // 能拉起腾讯视频


                appLaunchWhiteList = ['wechat', 'mqq', 'app', 'qqbrowser'];

                if (appLaunchWhiteList.indexOf(_this4.env) > -1) {
                  _this4.canOpenApp = true;
                }

                if (!((!env.isApp || !env.isTenvideoUnion) && !env.isMqq && !env.isWechat)) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 10;
                return _this4.requestWhiteList();

              case 10:
                whiteList = _context2.sent;
                ua = navigator.userAgent;
                i = 0, len = whiteList.length;

              case 13:
                if (!(i < len)) {
                  _context2.next = 30;
                  break;
                }

                app = whiteList[i];

                if (!(app.ua && app.ua.length > 0)) {
                  _context2.next = 27;
                  break;
                }

                j = 0, _len = app.ua.length;

              case 17:
                if (!(j < _len)) {
                  _context2.next = 27;
                  break;
                }

                conf = app.ua[j];

                if (!(conf && ua.match(new RegExp(conf.rule, 'i')))) {
                  _context2.next = 24;
                  break;
                }

                _this4.canLoginWechat = app.enableWechatLogin;
                _this4.canLoginQQ = app.enableQQLogin;
                _this4.canOpenApp = app.enableOpenApp;
                return _context2.abrupt("break", 27);

              case 24:
                j++;
                _context2.next = 17;
                break;

              case 27:
                i++;
                _context2.next = 13;
                break;

              case 30:
                if (_this4.isPrivateMode) {
                  _this4.canLoginQQ = false;
                  _this4.canLoginWechat = false;
                }

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    requestWhiteList: function requestWhiteList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve) {
                  if (cacheWhiteList) {
                    return resolve(cacheWhiteList);
                  }

                  _this5.wujiRequest().then(function (res) {
                    if (res && Array.isArray(res.data) && res.data.length > 0) {
                      cacheWhiteList = res.data;
                      return resolve(res.data);
                    }

                    resolve([]);
                  })["catch"](function () {
                    resolve([]);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    wujiRequest: function wujiRequest() {
      // eslint-disable-next-line
      var dataPreload = window._dataPreload;

      if (dataPreload && dataPreload.LoginPanel) {
        return Promise.resolve(dataPreload.LoginPanel);
      } // http://wuji.oa.com/p/edit?appid=vip&schemaid=login-white-list


      return request('https://v.qq.com/cache/wuji/object/?appid=vip&schemaid=login-white-list&schemakey=bfe09fad42e44099953f2739ebab8cb9&link=1', {
        link_query: 'include=rule'
      }, {
        withCredentials: false
      });
    },
    popup: function popup() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (param) {
        var _param$jumpUrl = param.jumpUrl,
            jumpUrl = _param$jumpUrl === void 0 ? '' : _param$jumpUrl,
            iframe = param.iframe,
            onLogin = param.onLogin,
            _param$desc = param.desc,
            desc = _param$desc === void 0 ? '' : _param$desc,
            isLoginExpired = param.isLoginExpired;
        this.jumpUrl = jumpUrl;
        this.insideIframe = iframe;
        this.onLogin = onLogin;
        this.desc = desc;

        if (isLoginExpired) {
          this.isLogin = false;
          this.isLoginExpired = true;
        }
      }

      this.visible = true;
      report.expose({
        f_module: this.isLogin ? '切换登录' : '登录',
        f_type: 0
      });
      this.doReport('expose', 'qq');
      this.doReport('expose', 'wx');
    },
    hide: function hide() {
      this.visible = false;
    },
    actionLogin: function actionLogin(type) {
      this.doReport('click', type);
      if (type === 'qq' && env.isMqq || type === 'wx' && env.isWechat && !this.canLoginWechat) return;

      if (type === 'wx' && !this.canLoginWechat || type === 'qq' && !this.canLoginQQ) {
        if (this.canOpenApp && !this.inWxMiniApp) {
          this.launchApp();
        } else if (type === 'wx' && !env.isWechat || type === 'qq' && !env.isMqq) {
          this.clipboard();
        }
      } else if (this.env !== 'mqq') {
        if (!this.isAgreementChecked) {
          return atom.toast('请先勾选“同意《用户协议》、《隐私政策》、《儿童隐私保护声明》、《个人信息采集清单》和《第三方信息共享清单》”', {
            duration: 1000
          } // 产品设计1秒消失
          );
        }

        var param = {
          type: type
        };

        if (this.jumpUrl) {
          param.url = this.jumpUrl;
        }

        this.switchLogin(param);
      }
    },
    switchLogin: function switchLogin() {
      var _this6 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (env.isWeChatMiniProgram && util.getUrlParam('mpcookie')) {
        return login.openLogin();
      }

      if (typeof param.onLogin === 'function') {
        this.onLogin = param.onLogin;
      }

      if (param.jumpUrl) {
        this.jumpUrl = param.jumpUrl;
      }

      if (param.type === 'wx' && !this.canLoginWechat) {
        this.visible = true;
      } else {
        var isCallbacked = false;

        var onLogin = function onLogin(response) {
          if (!isCallbacked) {
            // 避免重复调用
            setTimeout(function () {
              isCallbacked = true;

              _this6.onSuccessLogin(param, response);

              atom.hideLoading();
            }, 500);
          }
        };

        if (env.isApp) {
          // 包括 phone 和 pad
          atom.once('onActionLoginFinish', onLogin);
        }

        if (env.isWeishi) {
          this.doLoginWeishi().then(function (isLogin) {
            onLogin({
              result: {
                isLogin: isLogin
              },
              errCode: 0
            });
          });
        } else if (env.isQQSports || env.isQQMusic || env.isTenvideoUnion) {
          atom.openLogin(param.type).then(function () {
            onLogin({
              result: {
                isLogin: true
              },
              errCode: 0
            });
          });
        } else if (env.isApp && atom.switchLogin) {
          atom.showLoading('正在登录', {
            timeout: 5000
          });
          atom.switchLogin(param.type).then(function (res) {
            if (!env.isAndroid) {
              onLogin(res);
            }
          });
          atom.once('onSwitchLoginStateResponse', function (res) {
            if (res && res.result && res.result.switchResult) {
              onLogin(res);
            }
          });
        } else if (this.insideIframe) {
          var ru = encodeURIComponent(window.parent.location.href);
          var jumpUrl = "http://film.qq.com/weixin/login.html?ru=".concat(ru, "&type=").concat(param.type);
          window.parent.location.href = jumpUrl;
        } else {
          login.openLogin(param);
        }

        this.hide();
      }
    },
    delay: function delay() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
      return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
      });
    },
    logout: function logout() {
      return new Promise(function (resolve) {
        login.logout(resolve);
      });
    },
    loadScript: function loadScript(id, url) {
      return new Promise(function (resolve) {
        util.loadScript(id, url, resolve);
      });
    },
    // 在微视APP内，使用APP登录组件
    doLoginWeishi: function doLoginWeishi() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var wsCookies;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (env.isTenvideoUnion) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this7.logout();

              case 3:
                _context4.prev = 3;

                if (!(cookie.get('openid') || env.isIphone)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return atom.invoke('weishi.logout');

              case 7:
                if (!env.isAndroid) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 10;
                return _this7.delay(100);

              case 10:
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](3);
                console.error('weishi.logout', _context4.t0);

              case 15:
                // 清cookie原因是，微视端内需要先清登录态再拉登录，而安卓端会出现退出登录后仍存在票据信息
                // 需要清除票据保证退出登录成功
                wsCookies = ['appid', 'openid', 'accessToken', 'refreshToken', 'iAuthType', 'sUid', 'sSessionKey', 'vqq_appid', 'vqq_access_token', 'vqq_vuserid', 'vqq_vusession', 'vqq_openid'];
                wsCookies.forEach(function (key) {
                  cookie.remove(key, {
                    domain: 'qq.com',
                    path: '/'
                  });
                });
                _context4.prev = 17;
                _context4.next = 20;
                return atom.openLogin();

              case 20:
                return _context4.abrupt("return", true);

              case 23:
                _context4.prev = 23;
                _context4.t1 = _context4["catch"](17);
                console.error('weishi.login', _context4.t1);

              case 26:
                return _context4.abrupt("return", false);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 12], [17, 23]]);
      }))();
    },
    launchApp: function launchApp() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var schemeUrl;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                schemeUrl = "tenvideo2://?action=10&openurl=".concat(encodeURIComponent(_this8.pageUrl));

                if (_this8.pageUrl.match(/^(tenvideo2|txvideo):\/\//)) {
                  schemeUrl = _this8.pageUrl;
                }

                _this8.hide();

                _context5.next = 5;
                return openApp.launch(schemeUrl);

              case 5:
                if (_context5.sent) {
                  _context5.next = 7;
                  break;
                }

                // 拉起失败
                location.href = "https://film.qq.com/h5/app/openapp.html?openurl=".concat(encodeURIComponent(_this8.pageUrl), "&auto=0");

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    clipboard: function clipboard() {
      // eslint-disable-next-line
      new Clipboard({
        text: this.pageUrl || location.href,
        success: function success() {
          atom.toast('已复制链接');
        },
        error: function error() {
          atom.toast('暂不支持复制功能，可手动分享此页面到微信打开或者直接复制该页面地址！');
        }
      });
      this.hide();
    },
    descTextClick: function descTextClick(e) {
      if (e.target.id === 'clipboard') {
        this.clipboard();
      }
    },
    onSuccessLogin: function onSuccessLogin(param, res) {
      if ((env.isApp || env.isWeishi || env.isQQSports || env.isQQMusic || env.isTenvideoUnion) && typeof this.onLogin === 'function') {
        var result = res && res.result && res.errCode === 0 ? res.result : null;
        this.onLogin(result);
      } else if (param.url || param.jumpUrl) {
        // 修改化定义的跳转地址
        location.href = param.url || param.jumpUrl;
      } else if (typeof window.reinit === 'function') {
        // 调用全局注册的 reinit 方法
        window.reinit();
      } else {
        // 刷新当前页面
        location.reload();
      }
    },
    doReport: function doReport() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'expose';
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'qq';
      var loginType = type === 'qq' ? 'QQ' : '微信';
      var actionType = this.isLogin ? '切换' : '登录';
      var params = {
        f_module: this.isLogin ? '切换登录' : '登录',
        f_resource: "".concat(loginType).concat(actionType, "\u6309\u94AE"),
        f_type: 4
      };

      if (!env.isApp && (type === 'qq' && !this.canLoginQQ || type === 'wx' && !this.canLoginWechat)) {
        if (type === 'qq' && env.isMqq || type === 'wx' && env.isWechat) {
          params.f_resource = "".concat(loginType, "\u65E0\u6CD5").concat(actionType, "\uFF08").concat(env.isMqq ? 'QQ' : '微信', "\u5185\uFF09");
        } else if (this.canOpenApp) {
          params.f_resource = "".concat(loginType, "\u65E0\u6CD5").concat(actionType, "\uFF0C\u62C9\u817E\u8BAF\u89C6\u9891\u6309\u94AE");
        } else {
          params.f_resource = "".concat(loginType, "\u65E0\u6CD5").concat(actionType, "\uFF0C\u590D\u5236\u94FE\u63A5\u6309\u94AE");
        }
      }

      report[event](params);
    },
    openAgreement: function openAgreement(url) {
      // iframe 跳转全屏展示
      if (this.insideIframe) {
        window.parent.location.href = url;
        return;
      }

      atom.openUrl(url);
    }
  },
  install: function install(Vue) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Object.keys(option).forEach(function (key) {
      if (hasOwn.call(instance, key) && option[key]) {
        instance[key] = option[key];
      }
    }); // eslint-disable-next-line no-param-reassign

    Vue.prototype.$openLogin = function (param) {
      instance.updateState(function () {
        if (env.isWeishi || env.isQQSports || env.isQQMusic || env.isKidApp || env.isTenvideoUnion || env.isWeChatMiniProgram && util.getUrlParam('mpcookie')) {
          instance.switchLogin(param);
        } else {
          instance.popup(param);
        }
      });
    }; // eslint-disable-next-line no-param-reassign


    Vue.prototype.$switchLogin = function (param) {
      instance.updateState(function () {
        instance.switchLogin(param);
      });
    }; // eslint-disable-next-line no-param-reassign


    Vue.prototype.$checkLogin = function (param) {
      return new Promise(function (resolve) {
        login.isStrictLogin(function (isLogin) {
          if (isLogin) {
            resolve(true);
          } else {
            resolve(false);
            instance.updateState(function () {
              instance.isLoginExpired = login.isLogin() && !isLogin;
              instance.isLogin = login.isLogin();
              instance.popup(param);
            });
          }
        });
      });
    };
  }
};